// 2 state digits · 5 PAN letters · 4 PAN digits · 1 PAN letter · 1 entity char
// [1-9A-Z] · 'Z' (reserved). The trailing checksum char is NOT validated — it's
// optional here — so both 14-char and full 15-char GSTINs (e.g. 07AAECW3507D1ZM)
// are accepted.
export const RX_GSTIN = /^\d{2}[A-Z]{5}\d{4}[A-Z][1-9A-Z]Z[0-9A-Z]?$/;
export const RX_PAN = /^[A-Z]{5}\d{4}[A-Z]$/;
export const RX_IFSC = /^[A-Z]{4}0[A-Z0-9]{6}$/;
export const RX_PIN = /^\d{6}$/;
export const RX_MOBILE = /^\d{10}$/;
export const RX_HSN = /^\d{4,8}$/;
export const RX_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const GST_STATE_MAP: Record<string, string> = {
  '01': 'Jammu & Kashmir', '02': 'Himachal Pradesh', '03': 'Punjab', '04': 'Chandigarh',
  '05': 'Uttarakhand', '06': 'Haryana', '07': 'Delhi', '08': 'Rajasthan',
  '09': 'Uttar Pradesh', '10': 'Bihar', '11': 'Sikkim', '12': 'Arunachal Pradesh',
  '13': 'Nagaland', '14': 'Manipur', '15': 'Mizoram', '16': 'Tripura',
  '17': 'Meghalaya', '18': 'Assam', '19': 'West Bengal', '20': 'Jharkhand',
  '21': 'Odisha', '22': 'Chhattisgarh', '23': 'Madhya Pradesh', '24': 'Gujarat',
  '27': 'Maharashtra', '28': 'Andhra Pradesh', '29': 'Karnataka', '30': 'Goa',
  '32': 'Kerala', '33': 'Tamil Nadu', '36': 'Telangana',
};

/** Return the state name for the first 2 digits of a GSTIN, or null. */
export function detectStateFromGstin(gstin: string): { code: string; name: string } | null {
  if (!gstin || gstin.length < 2) return null;
  const code = gstin.slice(0, 2);
  const name = GST_STATE_MAP[code];
  return name ? { code, name } : null;
}
